(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ka-hide-empty"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The theme editor re-executes block javascript on every re-render —
       guard so the observer attaches once, and just re-scan on re-render. */
    if (window.__kaHideEmptyInit) {
      if (window.__kaHideEmpty) window.__kaHideEmpty();
      return;
    }
    window.__kaHideEmptyInit = true;

    const ATTR = 'data-ka-he';
    const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT', 'LINK', 'META']);
    const SKIP_CLASSES = ['visually-hidden', 'hidden', 'ka-he-editor'];
    /* Anything matching this counts as content even without text. */
    const MEDIA =
      'img,picture,video,audio,iframe,svg,canvas,object,embed,model-viewer,input,select,textarea,button,hr,.divider,[data-ka-keep]';
    const REC_ITEMS = '.resource-list__item, slideshow-slide, product-card, .product-card';
    const PLACEHOLDER = '[data-placeholder="true"]';
    let skipPlaceholders = false;

    function contentRoot() {
      return document.getElementById('MainContent') || document.querySelector('main') || document.body;
    }

    function readConfig() {
      const el = document.querySelector('script[data-ka-he-config]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    /* One selector per line; invalid lines are dropped instead of breaking
       the whole scan. */
    const probe = document.createDocumentFragment();
    function selectorList(str) {
      return (str || '')
        .split('\n')
        .map(function (s) {
          return s.trim();
        })
        .filter(function (s) {
          if (!s) return false;
          try {
            probe.querySelector(s);
            return true;
          } catch (e) {
            return false;
          }
        })
        .join(',');
    }

    function skipped(el) {
      if (SKIP_TAGS.has(el.tagName) || el.hidden || el.hasAttribute(ATTR)) return true;
      if (skipPlaceholders && el.matches(PLACEHOLDER)) return true;
      for (let i = 0; i < SKIP_CLASSES.length; i++) {
        if (el.classList.contains(SKIP_CLASSES[i])) return true;
      }
      return false;
    }

    /* True when the node has visible text or media/controls somewhere below
       it, ignoring anything already marked empty. */
    function hasContent(node, keep) {
      for (const child of node.childNodes) {
        if (child.nodeType === 3) {
          if (child.textContent.trim()) return true;
          continue;
        }
        if (child.nodeType !== 1 || skipped(child)) continue;
        if (child.matches(keep) || hasContent(child, keep)) return true;
      }
      return false;
    }

    function depth(el) {
      let d = 0;
      while ((el = el.parentElement)) d++;
      return d;
    }

    function updateCount(cfg, count) {
      const el = document.querySelector('.ka-he-editor [data-ka-he-count]');
      if (!el || !cfg || cfg.mode === 'off') return;
      const text =
        count === 0
          ? 'Nothing empty on this page'
          : count + (count === 1 ? ' element' : ' elements') + ' hidden on the storefront';
      /* Only write on change — the write itself is a mutation we observe. */
      if (el.textContent !== text) el.textContent = text;
    }

    function run() {
      const cfg = readConfig();
      const root = contentRoot();

      document.querySelectorAll('[' + ATTR + ']').forEach(function (el) {
        el.removeAttribute(ATTR);
      });
      if (!cfg || cfg.mode === 'off') return;

      const mode = cfg.mode === 'mark' ? 'mark' : 'hide';
      skipPlaceholders = !!cfg.placeholders;
      const keep = [MEDIA, selectorList(cfg.keep)].filter(Boolean).join(',');
      let count = 0;

      function mark(el) {
        el.setAttribute(ATTR, mode);
        count++;
      }

      /* 1. Product recommendations that came back without products. Only
         once performed — before that Horizon is still fetching them. */
      if (cfg.recs) {
        root.querySelectorAll('product-recommendations').forEach(function (rec) {
          if (rec.dataset.recommendationsPerformed === 'true' && !rec.querySelector(REC_ITEMS)) mark(rec);
        });
      }

      /* 2. Accordion rows: empty content and/or blank heading. */
      if (cfg.rowsEmpty || cfg.rowsUntitled) {
        root.querySelectorAll('.accordion details').forEach(function (details) {
          const parent = details.parentElement;
          const row = parent && parent.tagName === 'ACCORDION-CUSTOM' ? parent : details;
          if (row.hasAttribute(ATTR)) return;

          const summary = details.querySelector(':scope > summary');
          const body = details.querySelector(':scope > .details-content');
          const untitled = summary && !summary.textContent.trim() && !summary.querySelector('img');
          const empty = body && !hasContent(body, keep);

          if ((cfg.rowsUntitled && untitled) || (cfg.rowsEmpty && empty)) mark(row);
        });
      }

      /* 3. Blocks, deepest first, so a group whose children were all hidden
         is evaluated after them and hides as well. */
      const selectors = [];
      if (cfg.text) selectors.push('.text-block');
      if (cfg.blocks) selectors.push('.shopify-block:not(.shopify-app-block)');
      if (cfg.appBlocks) selectors.push('.shopify-app-block');
      if (cfg.recs) selectors.push('.product-recommendations-wrapper');
      if (cfg.accordions) selectors.push('.accordion');
      if (cfg.groups) selectors.push('.group-block');
      const extra = selectorList(cfg.extra);
      if (extra) selectors.push(extra);

      if (selectors.length) {
        Array.from(root.querySelectorAll(selectors.join(',')))
          .map(function (el) {
            return [el, depth(el)];
          })
          .sort(function (a, b) {
            return b[1] - a[1];
          })
          .forEach(function (pair) {
            const el = pair[0];
            if (el.hasAttribute(ATTR) || el.matches(keep)) return;
            if (!hasContent(el, keep)) mark(el);
          });
      }

      /* 4. Sections showing only placeholder cards. The section heading is
         real text, so the generic check would keep it — instead: hide when
         no card of the same kind (tag + first class) is a real one. */
      if (cfg.placeholders) {
        root.querySelectorAll('.shopify-section').forEach(function (section) {
          if (section.hasAttribute(ATTR)) return;
          const placeholders = section.querySelectorAll(PLACEHOLDER);
          if (!placeholders.length) return;
          const hasReal = Array.from(placeholders).some(function (ph) {
            const cls = ph.classList[0];
            const kind = ph.tagName.toLowerCase() + (cls ? '.' + CSS.escape(cls) : '');
            return section.querySelector(kind + ':not(' + PLACEHOLDER + ')');
          });
          if (!hasReal) mark(section);
        });
      }

      /* 5. Sections in the page content left with nothing visible. */
      if (cfg.sections) {
        root.querySelectorAll('.shopify-section').forEach(function (section) {
          if (!section.hasAttribute(ATTR) && !hasContent(section, keep)) mark(section);
        });
      }

      updateCount(cfg, count);
    }

    let queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        run();
      });
    }
    window.__kaHideEmpty = schedule;

    function start() {
      run();
      /* Attributes are not observed: our own markers (and accordion open
         state) must not retrigger the scan. */
      new MutationObserver(schedule).observe(contentRoot(), {
        childList: true,
        subtree: true,
        characterData: true
      });
      document.addEventListener('shopify:section:load', schedule);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-product-labels"] && !Shopify.designMode) return;
  try {
    (function () {
    // Læg labels oven på produktbilledet. Ankeret er billedets viewport
    // (slideshow-container), så labels ikke lander oven på miniaturerne.
    function anchorFor(gallery) {
      return (
        gallery.querySelector('slideshow-container') ||
        gallery.querySelector('.product-media-container') ||
        gallery
      );
    }

    function place() {
      document.querySelectorAll('[data-ka-labels-source]').forEach(function (source) {
        var section = source.closest('.shopify-section') || document;
        var gallery = section.querySelector('media-gallery');
        if (!gallery) return;

        var labels = source.querySelector('.ka-badges');
        if (!labels) return;

        var sig = source.dataset.kaLabelsSig || '';
        var placed = gallery.querySelector('.ka-badges--placed[data-ka-labels-sig="' + sig + '"]');
        if (placed) return;

        // Ryd kun op efter denne blok (signaturen starter med blokkens id),
        // så flere label-blokke på samme side ikke fjerner hinandens labels.
        var owner = sig.split(':')[0] + ':';
        gallery.querySelectorAll('.ka-badges--placed').forEach(function (stale) {
          if ((stale.getAttribute('data-ka-labels-sig') || '').indexOf(owner) === 0) stale.remove();
        });

        var corner = source.dataset.kaLabelsCorner || 'top-left';
        var offset = source.dataset.kaLabelsOffset || '10';

        var clone = labels.cloneNode(true);
        clone.classList.add('ka-badges--placed', 'ka-badges--' + corner);
        clone.setAttribute('data-ka-labels-sig', sig);
        clone.style.setProperty('--ka-placed-offset', offset + 'px');

        var anchor = anchorFor(gallery);
        if (getComputedStyle(anchor).position === 'static') {
          anchor.style.position = 'relative';
        }
        anchor.appendChild(clone);
      });
    }

    function watch() {
      place();
      document.querySelectorAll('[data-ka-labels-source]').forEach(function (source) {
        var section = source.closest('.shopify-section');
        if (!section || section.dataset.kaLabelsObserved) return;
        section.dataset.kaLabelsObserved = 'true';
        // Hvis Horizon genopbygger billedgalleriet (fx ved variantskift), placeres labels igen.
        new MutationObserver(function () {
          place();
        }).observe(section, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }

    document.addEventListener('shopify:section:load', function () {
      setTimeout(watch, 0);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(place, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
